import {createSlice, PayloadAction} from '@reduxjs/toolkit';
import {GAPageInfo, GAUserInfo, GAContextSelectedInfo} from '../../types/analyticsTypes';
import {generatePageAndSection} from '../../utils/analyticsUtils';

interface AnalyticsState {
  prevPage: GAPageInfo;
  user: GAUserInfo;
  contextSelected: GAContextSelectedInfo | null;
}

const initialState: AnalyticsState = {
  prevPage: {
    name: '',
    section: '',
    prev_page_name: '',
    prev_page_url: '',
  },
  user: {
    id: '',
    company_id: '',
    role: '',
    category: '',
  },
  contextSelected: null,
};

const analyticsSlice = createSlice({
  name: 'analytics',
  initialState,
  reducers: {
    setPrevPage(state, action: PayloadAction<string>) {
      if (state.prevPage) {
        state.prevPage.prev_page_url = action.payload;
        state.prevPage.prev_page_name = generatePageAndSection(
          action.payload
        ).page;
      }
    },
    setUserRole(state, action: PayloadAction<string>) {
      state.user.role = action.payload;
    },
    setUserDetailsGA(state, action: PayloadAction<GAUserInfo>) {
      if (action.payload) {
        state.user.id = action.payload.id;
        state.user.company_id = action.payload.company_id;
        state.user.category = action.payload.category;
      }
    },
    setContextSelected(state, action: PayloadAction<GAContextSelectedInfo>) {
      state.contextSelected = action.payload;
    },
    clearContextSelected(state) {
      state.contextSelected = null;
    },
    resetAnalyticUserState(state) {
      state.user = initialState.user;
      state.contextSelected = null;
    },
  },
});

export const {
  setPrevPage,
  setUserRole,
  setUserDetailsGA,
  setContextSelected,
  clearContextSelected,
  resetAnalyticUserState,
} = analyticsSlice.actions;

export default analyticsSlice.reducer;
